/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Heading_TaglineInputs */

const en_about_heading_tagline = /** @type {(inputs: About_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A little signal about the person behind the work`)
};

const ar_about_heading_tagline = /** @type {(inputs: About_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لمحة عن الشخص الذي يقف خلف هذا العمل`)
};

const bn_about_heading_tagline = /** @type {(inputs: About_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কাজের পেছনের মানুষটা সম্পর্কে একটু জানুন`)
};

const de_about_heading_tagline = /** @type {(inputs: About_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein kurzer Blick auf den Menschen hinter der Arbeit`)
};

const es_about_heading_tagline = /** @type {(inputs: About_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una mirada breve a la persona detrás del trabajo`)
};

const fr_about_heading_tagline = /** @type {(inputs: About_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un aperçu de la personne derrière le travail`)
};

const pt_about_heading_tagline = /** @type {(inputs: About_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um olhar sobre a pessoa por trás do trabalho`)
};

const zh_about_heading_tagline = /** @type {(inputs: About_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简单介绍一下作品背后的人`)
};

const tr_about_heading_tagline = /** @type {(inputs: About_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İşin arkasındaki kişi hakkında küçük bir sinyal`)
};

const ru_about_heading_tagline = /** @type {(inputs: About_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Коротко о человеке, который стоит за работой.`)
};

const pl_about_heading_tagline = /** @type {(inputs: About_Heading_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mały sygnał o osobie stojącej za pracą`)
};

/**
* | output |
* | --- |
* | "A little signal about the person behind the work" |
*
* @param {About_Heading_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const about_heading_tagline = /** @type {((inputs?: About_Heading_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Heading_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_about_heading_tagline(inputs)
	if (locale === "bn") return bn_about_heading_tagline(inputs)
	if (locale === "de") return de_about_heading_tagline(inputs)
	if (locale === "es") return es_about_heading_tagline(inputs)
	if (locale === "fr") return fr_about_heading_tagline(inputs)
	if (locale === "pt") return pt_about_heading_tagline(inputs)
	if (locale === "zh") return zh_about_heading_tagline(inputs)
	if (locale === "tr") return tr_about_heading_tagline(inputs)
	if (locale === "ru") return ru_about_heading_tagline(inputs)
	if (locale === "pl") return pl_about_heading_tagline(inputs)
	return en_about_heading_tagline(inputs)
});